<template>
  <div class="ai-bulk-custom-question-input">
    <textarea
      v-model="bulkQuestionText"
      rows="5"
      placeholder="One question per line — write them the way a customer would ask.

What's the best on-page SEO tool for WordPress?
Is PageOptimizer Pro good for agencies?"
    ></textarea>
    <p>Tip: natural, customer-style phrasing gets the most accurate visibility results.</p>
    <div v-if="bulkValidationMessage" class="ai-bulk-custom-question-input__error">
      {{ bulkValidationMessage }}
    </div>
    <button
      type="button"
      class="ai-bulk-custom-question-input__add"
      :disabled="isBulkAddDisabled"
      @click="submit"
    >
      Add
    </button>
  </div>
</template>

<script>
import {
  CUSTOM_QUESTION_ERRORS,
  CUSTOM_QUESTION_MAX_LENGTH,
  normalizeQuestionText,
} from '../utils'

const MAX_BULK_QUESTIONS = 5

export default {
  name: 'BulkCustomQuestionInput',
  props: {
    existingQuestions: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      bulkQuestionText: '',
    }
  },
  computed: {
    bulkLines () {
      return this.bulkQuestionText
        .split('\n')
        .map((question) => question.trim())
        .filter(Boolean)
    },
    uniqueBulkQuestions () {
      const existingTexts = new Set(this.existingQuestions.map((question) => normalizeQuestionText(question.text)))
      const seenTexts = new Set()

      return this.bulkLines.filter((question) => {
        const normalizedQuestion = normalizeQuestionText(question)
        if (!normalizedQuestion || existingTexts.has(normalizedQuestion) || seenTexts.has(normalizedQuestion)) {
          return false
        }

        seenTexts.add(normalizedQuestion)
        return true
      })
    },
    bulkValidationMessage () {
      if (!this.bulkLines.length) {
        return ''
      }

      if (this.bulkLines.some((question) => question.length > CUSTOM_QUESTION_MAX_LENGTH)) {
        return CUSTOM_QUESTION_ERRORS.maxLength
      }

      if (this.uniqueBulkQuestions.length > MAX_BULK_QUESTIONS) {
        return 'Paste one question per line, maximum 5 question for once.'
      }

      if (!this.uniqueBulkQuestions.length) {
        return CUSTOM_QUESTION_ERRORS.duplicate
      }

      return ''
    },
    isBulkAddDisabled () {
      return !this.bulkLines.length || !!this.bulkValidationMessage
    },
  },
  methods: {
    submit () {
      if (this.isBulkAddDisabled) {
        return
      }

      this.$emit('save', this.uniqueBulkQuestions)
      this.bulkQuestionText = ''
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-bulk-custom-question-input {
  margin-top: 8px;
  margin-bottom: 18px;
  text-align: center;

  textarea {
    width: 100%;
    min-height: 118px;
    border: 1px solid var(--v-gray12Color-base);
    border-radius: 4px;
    background: var(--v-cardBg-base);
    color: var(--v-blackColor-base);
    font-size: 14px;
    line-height: 2;
    outline-color: var(--v-gray12Color-base);
    padding: 10px;
    resize: vertical;
  }

  p {
    color: var(--v-darkGrayColor-base);
    font-size: 12px;
    letter-spacing: 0.12px;
    margin: 0;
    text-align: left;
  }
}

.ai-bulk-custom-question-input__add {
  width: 358px;
  height: 44px;
  border: 0;
  border-radius: 30px;
  background: var(--v-mainColor-base);
  color: var(--v-cardBg-base);
  cursor: pointer;
  font-size: 16px;
  line-height: 1.5;
  margin-top: 16px;
  padding: 10px 20px;

  &:disabled {
    background: var(--v-darkGrayColor-base);
    cursor: not-allowed;
  }
}

.ai-bulk-custom-question-input__error {
  color: var(--v-red11Color-base);
  font-size: 12px;
  letter-spacing: 0.12px;
  margin-top: 10px;
  text-align: center;
}
</style>
